export const optionsEnum = {
  EMAIL: "email",
  PHONE: "phone",
};
export const getBrowserLocale = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0].substr(0, 2);
  }
  if (navigator.userLanguage) {
    return navigator.userLanguage.substr(0, 2);
  }
  return navigator.language;
};

export const orderNodes = (el1, el2) => {
  if (el1.order > el2.order) return 1;
  else return -1;
};
